import Vue from 'vue';
import startCase from 'lodash.startcase';
import upperCase from 'lodash.uppercase';
import { getOldLevelSlug } from '@/shared/soco-levels';
const Config = require('~/config/default.env').default;

function ucwords(value) {
  return (value + '').toLowerCase().replace(/^(.)|\s+(.)/g, function ($1) {
    return $1.toUpperCase();
  });
}

Vue.filter('cnvrtNumberToK', (numb) => {
  if (typeof numb == 'number') {
    if (numb > 999) {
      numb = Math.floor(numb / 100) / 10 + 'K';
    }
    return numb.toString().replace(/\./gim, ',');
  } else {
    return '0';
  }
});

Vue.filter('ucwordsAttributeName', function (value) {
  const newValue = ucwords(value);
  return newValue.replace(/\bMl\b/g, 'ml').replace(/\bGr\b/g, 'gr');
});

Vue.filter('currency', function (value) {
  value = parseInt(value);
  const res = value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');

  return res === '0' ? '-' : res;
});

Vue.filter('dMyyyy', function (value) {
  return dayjs(value).format('LL');
});

Vue.filter('nFormatter', function (item) {
  if (!item) {
    return 0;
  }
  if (item >= 1000000000) {
    item = (item / 1000000000).toFixed(1).replace(/\.0$/, '') + 'g';
    item = item.replace('.', ',');
  } else if (item >= 1000000) {
    item = (item / 1000000).toFixed(1).replace(/\.0$/, '') + 'm';
    item = item.replace('.', ',');
  } else if (item >= 1000) {
    item = (item / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    item = item.replace('.', ',');
  }
  return item;
});

const slug = function (value) {
  if (typeof value === 'string') {
    let s = value.toLowerCase();
    s = s
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '-')
      .replace(/^-+|-+$/g, '');
    return s;
  }

  return null;
};

Vue.filter('slug', slug);

Vue.filter('deslug', (value) => {
  return value
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
});

Vue.filter('ucwords', function (value) {
  return (value + '').toLowerCase().replace(/^(.)|\s+(.)/g, function ($1) {
    return $1.toUpperCase();
  });
});

Vue.filter('ucfirst', function (value) {
  if (typeof value !== 'string') {
    return '';
  }
  const stringAfterToLowerCase = value.toLowerCase();
  return stringAfterToLowerCase.charAt(0).toUpperCase() + stringAfterToLowerCase.slice(1);
});

Vue.filter('rating', function (value) {
  if (value) {
    return Math.floor(Number(value) * 10) / 10;
  }
  return 0;
});

Vue.filter('userLevel', function (value) {
  if (value) {
    try {
      return `user-level--${getOldLevelSlug(value) || value.toLowerCase().trim().replace(/\ /g, '-')}`;
    } catch (err) {
      return '';
    }
  }
});

Vue.filter('productrating', function (value) {
  return Number(value).toPrecision(2);
  // return Math.trunc(Number(value) * 10) / 10;
  // return Number(value).toFixed(1)
});

Vue.filter('stripHTML', function (value) {
  if (typeof value === 'string') {
    return value.replace(/<[^>]*>/gi, '').replace(/&[^;]*;/gi, ' ');
  }
  return value;
});

Vue.filter('relativeTime', function (value) {
  return dayjs(value).fromNow();
});

Vue.filter('relativeTimeEn', function (value) {
  dayjs.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      m: '1m',
      mm: '%dm',
      h: '1h',
      hh: '%dh',
      d: '1d',
      dd: '%dd',
      M: '1mo',
      MM: '%dmo',
      y: '1yr',
      yy: '%dyr',
    },
  });
  return dayjs(value).locale('en').fromNow(true);
});

Vue.filter('trimRecentReviewContent', function (value) {
  return String(value).substr(0, 180) + '..';
});
Vue.filter('trimRecentReviewContentMobile', function (value) {
  return String(value).substr(0, 150) + '...';
});
Vue.filter('trimName', function (value) {
  if (!value) {
    return '';
  }
  let name = value;
  const word_length = 30;

  if (name.toString().length >= word_length) {
    name = name.toString().substr(0, word_length) + '...';
  }
  return name;
});
Vue.filter('trimBrandContent', function (value) {
  return String(value).substr(0, 100) + '..';
});
Vue.filter('trimContent', function (value) {
  return String(value).substr(0, 700) + '..';
});

Vue.filter('trimContentDesc', function (value) {
  return String(value).substr(0, 300) + '...';
});

Vue.filter('dateMonthYear', function (value) {
  return dayjs(value).format('DD MMM YYYY');
});

Vue.filter('productUrlReview', function (product) {
  let categorySlug = '';
  if (product.default_category) {
    categorySlug = slug(product.default_category.name);
  }
  if (categorySlug) {
    return `/product/${categorySlug}/${product.id}-${slug(product.name)}`;
  } else {
    return `/product/${
      product && product.parent_category && product.parent_category.link_rewrite
        ? product.parent_category.link_rewrite
        : 'default'
    }/${product.id}-${slug(product.name)}`;
  }
});

Vue.filter('generatedRatingTypeName', function (value) {
  const nameToLowerCase = value.toLowerCase();
  const removeWordIsStar = nameToLowerCase.replace('star_', '');
  const removeDash = removeWordIsStar.replace(/[_]/gi, ' ');
  return removeDash;
});

Vue.filter('serializeQS', function (obj) {
  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      const val = typeof obj[p] == 'object' ? JSON.stringify(obj[p]) : obj[p];
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
    }
  }
  return str.join('&');
});

Vue.filter('generateSortingProduct', function (value) {
  const textSorting = value.toLowerCase();
  if (textSorting === 'popular') {
    return '-review_stats.total_reviews';
  } else if (textSorting === 'order') {
    return '-total_orders';
  } else if (textSorting === 'newest') {
    return '-created_at';
  } else if (textSorting === 'oldest') {
    return 'created_at';
  } else if (textSorting === 'highest rating') {
    return '-review_stats.average_rating';
  } else if (textSorting === 'rating') {
    return '-review_stats.average_rating';
  } else if (textSorting === '-rating') {
    return 'review_stats.average_rating';
  } else if (textSorting === 'name') {
    return 'name';
  } else if (textSorting === '-name') {
    return '-name';
  } else {
    return 'review_stats.average_rating';
  }
});

Vue.filter('generateSortingProductV2', function (value) {
  const textSorting = value.toLowerCase();
  if (textSorting === 'popular') {
    return '-review_stats.total_reviews';
  } else if (textSorting === 'newest') {
    return 'newest';
  } else if (textSorting === 'highest rating') {
    return '-review_stats.average_rating';
  } else if (textSorting === 'rating') {
    return '-review_stats.average_rating,-total_reviews';
  } else if (textSorting === '-rating') {
    return 'review_stats.average_rating,total_reviews';
  } else if (textSorting === '-total_orders') {
    return 'most-purchased';
  } else if (textSorting === '-review_stats.total_reviews') {
    return 'most-review';
  } else if (textSorting === 'default_combination.price_after_discount') {
    return 'cheapest';
  } else if (textSorting === '-default_combination.price_after_discount') {
    return 'expensive';
  } else if (textSorting === 'name') {
    return 'aToZ';
  } else if (textSorting === '-name') {
    return 'zToA';
  } else if (textSorting === 'oldest') {
    return 'oldest';
  } else {
    return '';
  }
});

Vue.filter('rangeForAge', function (value) {
  const ageRange = Number(value);
  if (ageRange < 18) {
    return '< 18 th';
  } else if (ageRange > 18 && ageRange <= 24) {
    return '19 - 24 th';
  } else if (ageRange > 24 && ageRange <= 29) {
    return '25 - 29 th';
  } else if (ageRange > 29 && ageRange <= 34) {
    return '30 - 34 th';
  } else if (ageRange > 34 && ageRange <= 39) {
    return '35 - 39 th';
  } else {
    return '> 40 th';
  }
});

Vue.filter('imageCdn', (options) => {
  const host =
    'ENVIRONMENT' in Config && Config.ENVIRONMENT == 'production' ? config.SOCIOLLA_WEB_URL : 'https://www.soco.id';
  if (
    options &&
    options.image &&
    !options.image.includes('img-sociolla') &&
    !options.image.includes('soc-dashboard') &&
    !options.image.includes('soc-newplatform')
  ) {
    return `${host}/cdn-cgi/image/${options.config},format=auto,quality=100,dpr=1.5/${options.image}`;
  } else {
    return options.image;
  }
});

Vue.filter('productLinkV3', function (product) {
  const categoryName =
    product.default_category && product.default_category.name ? slug(product.default_category.name) : 'product';
  const productName = product.name ? slug(product.name) : 'default';
  const myId = product.my_sociolla_sql_id ? product.my_sociolla_sql_id : product.id;
  const productSlug = product.slug ? product.slug : `${myId}-${productName}`;
  if (product.is_active_in_lulla) {
    return `${Config.LULLA_WEB_URL}/${categoryName}/${productSlug}`;
  } else if (product.is_active_in_sociolla) {
    return `${Config.SOCIOLLA_WEB_URL}/${categoryName}/${productSlug}`;
  } else if (product.slug) {
    return `${Config.SOCIOLLA_WEB_URL}/${categoryName}/${product.slug}`;
  }
});

Vue.filter('combinationName', function (data) {
  let groupAttribute = '';
  let attribute;
  if (Object.entries(data).length) {
    for (attribute in data.attributes) {
      if (data.attributes.hasOwnProperty(attribute) && attribute !== 'non_specify') {
        groupAttribute += groupAttribute ? ' - ' : '';
        groupAttribute += `${attribute}: ${data.attributes[attribute].name}`;
      }
    }
    return this.ucwordsAttributeName(groupAttribute);
  } else {
    return '';
  }
});

Vue.filter('productLink', function (product) {
  const categoryName =
    product.default_category && product.default_category.name ? slug(product.default_category.name) : 'product';
  if (product.slug) {
    return `/${categoryName}/${product.slug}`;
  }
  const productName = product.name ? slug(product.name) : 'default';
  return `/${categoryName}/${product.id}-${productName}.html`;
});

Vue.filter('categoryLink', function (category) {
  if (Object.keys(category).length) {
    if (category.slug) {
      return `/${category.slug}`;
    }
    if (category.link_rewrite) {
      return `/${category.my_sociolla_sql_id}-${this.slug(category.link_rewrite)}`;
    }
    return `/${category.my_sociolla_sql_id}-${this.slug(category.name)}`;
  } else {
    return '/';
  }
});

Vue.filter('brandLink', function (brand) {
  if (brand.slug) {
    return `/${brand.slug}`;
  }
  if (brand.my_sociolla_sql_id) {
    return `/${brand.my_sociolla_sql_id}_${this.slug(brand.name)}`;
  }
  if (brand.my_soco_sql_id) {
    return `/${brand.my_soco_sql_id}_${this.slug(brand.name)}`;
  }
  return `/_${this.slug(brand.name)}`;
});

Vue.filter('changeAvailableName', function (name) {
  if (name === 'is_active_in_lulla') {
    return `Available at Lilla`;
  } else if (name === 'is_active_in_sociolla') {
    return `Available at Sociolla`;
  }
});

Vue.filter('expertRoleLabel', function (name) {
  const formatted = name.replace('_', ' ');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
});

Vue.filter('startCase', startCase);

Vue.filter('upperCase', upperCase);
